import { lazy, Suspense } from 'react';

import { useRegistryCheckModal } from 'v2/hooks/useRegistryCheckModal';

function RegistryBlockModalFallback(): null {
  return null;
}

const OriginalRegistryBlockModal = lazy(() =>
  import('@myeduzz-vertical/root/RegistryBlockModal').catch(() => ({
    default: RegistryBlockModalFallback
  }))
);

export default function RegistryBlockModal(props: MyEduzzRegistryBlockModalProps) {
  const { opened, isOwner } = props;

  useRegistryCheckModal(opened && isOwner);

  return (
    <Suspense fallback={null}>
      <OriginalRegistryBlockModal {...props} />
    </Suspense>
  );
}
